import React, { FC, memo, useCallback, useMemo } from 'react';
import { useTranslation } from '~/shared/utils/translation';
import { SORT_OPTIONS, SortOption } from './constants';
import { Dropdown } from '~/shared/components/Dropdown/Dropdown';

interface SortDropdownProps {
    sortOption: SortOption;
    handleSortChange: (newSortOption: SortOption) => void;
    showCheckmark?: boolean;
    className?: string;
}

export const SortDropdown: FC<SortDropdownProps> = ({
    sortOption,
    handleSortChange,
    showCheckmark = true,
    className,
}) => {
    const { translate } = useTranslation();

    const options = useMemo(
        () =>
            Object.entries(SORT_OPTIONS).map(([key, value]) => ({
                id: key,
                label: translate(`plp.${value}`),
                value,
            })),
        [],
    );

    const renderLabel = useCallback((selected: { value: SortOption }) => {
        const key = Object.entries(SORT_OPTIONS).find(([_, val]) => val === selected.value)?.[0];
        return key ? translate(`plp.${SORT_OPTIONS[key as keyof typeof SORT_OPTIONS]}`) : '';
    }, []);

    return (
        <Dropdown
            options={options}
            selectedValue={sortOption}
            onChange={handleSortChange}
            showCheckmark={showCheckmark}
            renderLabel={renderLabel}
            className={className}
        />
    );
};

export default memo(SortDropdown);
